import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEdit, FiTrash2, FiChevronUp, FiChevronDown } from 'react-icons/fi';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment-timezone';
import Loader from '../../Loader/loader'; // Assuming you save the loader in a separate file
import { Tooltip } from 'react-tooltip'; // Import Tooltip from react-tooltip
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { User } from 'react-feather'; // Import the User icon

const Container = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 3px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
        color:#2B3497;

`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1; /* Ensure input takes up remaining space */
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000; /* Adjust color as needed */
`;

const TableContainer = styled.div`
  overflow-x: auto;
  margin-top: 20px;
`;
const ScrollableTableContainer = styled.div`
  margin-top:15px;
  max-height: 400px; /* Set the desired height */
  overflow-y: auto; /* Enable vertical scrolling */
  overflow-x: hidden; /* Disable horizontal scrolling */
  border: 1px solid #ddd; /* Optional: Add a border for better visibility */
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: linear-gradient(to bottom, #E6E6E6, #F2F2F2, #F5F5F5, #F3F3F3, #E9E9E9);
  box-shadow: 0px 10px 20px #0000001A;
  border-radius: 6px;
  opacity: 1;
`;

const TableHeader = styled.thead`
  background: linear-gradient(to bottom, #E6E6E6, #F2F2F2, #F5F5F5, #F3F3F3, #E9E9E9);
  color: #000;
`;

const TableRow = styled.tr``;

const TableHeaderCell = styled.th`
  padding: 10px;
  text-align: left;
  white-space: nowrap;
  font-size:14px;
  position: relative; /* Use relative positioning */
  cursor: pointer; /* Show that it's clickable */
  &:hover {
    color: #293495; /* Change color on hover */
  }

  /* Apply padding-right to make space for the sort icon */
  padding-right: 15px; 
`;

const SortIconContainer = styled.span`
  position: absolute;
  top: 57%;
  transform: translateY(-50%); /* Vertically center the icon */
  svg {
    font-size: 16px; /* Adjust the size of the icon */
    color: #000; /* Set the icon color */
  }
`;

const TableBody = styled.tbody``;

const TableCell = styled.td`
  padding: 10px;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
  font-size:14px;
`;

const IconContainer = styled.div`
  display: flex;
  gap: 10px;
`;
const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 5px;
  text-align:center;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;
const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  background: linear-gradient(#FFFFFF, #F5F5F5, #FFFFFF);
  box-shadow: 0px 0px 1px #0000004A;
  border-radius: 30px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 500px;
  height: auto; /* Use auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Push content and buttons to the top/bottom */
`;
const PopupG = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(#FFFFFF, #F5F5F5, #FFFFFF);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  padding: 20px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 90%;
  max-width: 900px;
  height: auto; /* Auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;

  @media (max-width: 768px) {
    width: 95%;
    padding: 15px;
    border-radius: 15px;
  }

  @media (max-width: 480px) {
    width: 98%;
    padding: 10px;
    border-radius: 10px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  margin-top: 20px; /* Add some space between content and buttons */
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
  margin-left: 10px; /* Add space between buttons */
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;



// Flexbox container to align labels and values neatly
const LabelValueContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 15px;
`;

const Label = styled.label`
  font-weight: 400;
  font-size: 16px;
  color: #000;
  width: 40%; /* Control label width */
  text-align: left; /* Ensure label is aligned to the left */
`;

const Value = styled.span`
  font-size: 16px;
  color: #000;
  width: 55%; /* Control value width */
  text-align: right; /* Ensure value is aligned to the right */
`;

// Dropdown styles
const DropdownContainer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DropdownLabel = styled.label`
  font-weight: 400;
  font-size: 16px;
  color: #000;
  width: 40%; /* Same as Label width */
  text-align: left;
`;

const StyledDropdown = styled.select`
  padding: 10px;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  width: 48%; /* Same as Value width */
  text-align: left;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #293495;
    outline: none;
  }

  option {
    padding: 8px;
  }
`;
const TextBoxContainer = styled.div`
  margin-top: 16px;
`;
const TextBoxContainerNew = styled.div`
display:flex;
  margin-top: 16px;
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  resize: none;
  background-color: #f9f9f9;
  &:focus {
    border-color: #293495;
    outline: none;
  }
`;
const Circle = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  // margin:14px 44px;
`;
const ProfileIcon = styled.div`
 width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
  position: relative;
`;
const StyledDatePicker = styled(DatePicker)`
  width: 235px;
  position: relative;
    left: 66px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 50%;
    padding: 8px 0;
    border: none;
    font-family: 'Segoe UI', Regular;
    background: transparent;
    border-bottom: 1px solid #2b3497;
    &:focus {
      outline: none;
      border-bottom: 2px solid #2b3497;
    }
  }
 

`;

const CloseButton = styled.span`
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 24px;
  cursor: pointer;
  color: #293495;
  font-weight: bold;
  &:hover {
    color: red;
  }
`;

const AppoinmentStatusPage = () => {
  const [tableData, setTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });

  const fetchVisitorTypeData = async () => {
    try {
      const empID = localStorage.getItem('employeeId');
      const responseOne = await axios.get(`/GroupAppointment/AppUser/${empID}`);
      console.log("responseOne", responseOne);
      setTableData(responseOne.data);
    } catch (error) {
      console.error('Error fetching Visitor Report data:', error);
    }
  };

  useEffect(() => {
    fetchVisitorTypeData();
  }, []);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredData = tableData.filter((item) => {
    return Object.values(item).some(value =>
      value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
    );
  });



  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const handlePageChange = (event) => {
    setCurrentPage(Number(event.target.value));
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const currentRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const renderSortIcon = (key) => {
    if (sortConfig.key === key) {
      return (
        <SortIconContainer>
          {sortConfig.direction === 'ascending' ? <FiChevronUp style={{ fontSize: '18px', fontWeight: 'bold', color: '#000' }} /> : <FiChevronDown style={{ fontSize: '18px', fontWeight: 'bold', color: '#000' }} />}
        </SortIconContainer>
      );
    }
    return (
      <SortIconContainer>
        <FiChevronDown style={{ opacity: 0.3 }} /> {/* Default icon */}
      </SortIconContainer>
    );
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
    const sortedData = [...tableData].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1;
      return 0;
    });
    setTableData(sortedData);
  };
  const handleSortG = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
    const sortedData = [...tableDataGroup].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1;
      return 0;
    });
    setTableDataGroup(sortedData);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const totalPageNumbers = Math.min(totalPages, 10); // Show up to 10 page numbers

    let startPage = Math.max(currentPage - 5, 1);
    let endPage = Math.min(startPage + totalPageNumbers - 1, totalPages);

    // Adjust startPage if endPage exceeds totalPages
    if (endPage === totalPages) {
      startPage = Math.max(totalPages - totalPageNumbers + 1, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <PaginationButton
          key={i}
          className={currentPage === i ? 'active' : ''}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </PaginationButton>
      );
    }

    return pageNumbers;
  };
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isPopupVisibleGroup, setIsPopupVisibleGroup] = useState(false);
  const [appointmentStatus, setAppointmentStatus] = useState('');
  const [groupLeaderDetails, setGroupLeaderDetails] = useState('');
  const [reasonForRescheduled, setReasonForRescheduled] = useState('');
  const [appointmentDate, setAppointmentDate] = useState(null); // State for appointment date
  const [loading, setLoading] = useState(false); // Add loading state
  const [timeLimits, setTimeLimits] = useState({ startHour: 9, startMinute: 0, endHour: 18, endMinute: 0 });

  const handleIconClick = async (item) => {
    const getMeetiingOn = async () => {
      try {
        const response = await axios.get('/Appointment/GetMeetingFromAndMeetingTo');
        const { meetingFrom, meetingTo } = response.data;

        const [startHour, startMinute] = meetingFrom.split(':').map(Number);
        const [endHour, endMinute] = meetingTo.split(':').map(Number);

        setTimeLimits({ startHour, startMinute, endHour, endMinute });
      } catch (error) {
        console.error('Error fetching meeting time limits:', error);
      }
    };
    getMeetiingOn();
    console.log("item", item);
    console.log("item", item.appointmentDate);
    const parsedDate = new Date(item.appointmentDate);
    setAppointmentDate(parsedDate)
    setAppointmentStatus(item.appointmentStatus)
    setGroupLeaderDetails(item)
    setIsPopupVisible(true); // Show the popup when the icon is clicked

  }
  const closePopup = () => {
    setAppointmentStatus('scheduled');
    setAppointmentDate(null);
    setReasonForRescheduled('');
    setIsPopupVisible(false);

  };
  const submitStaus = async () => {

    if (!reasonForRescheduled || reasonForRescheduled.trim() === '') {
      toast.error("Please fill the all fields")
      return
    }
    console.log("groupLeaderDetails", groupLeaderDetails);
    console.log("appointmentDate", appointmentDate);
    console.log("appointmentStatus", appointmentStatus);
    console.log("reasonForRescheduled", reasonForRescheduled);
    function formatDateForApi(appointmentDate) {
      const date = new Date(appointmentDate);
      return date.toISOString().slice(0, 19); // Extract YYYY-MM-DDTHH:mm:ss
    }
    const toLocalISOString = (date) => {
      const tzOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
      const localISOTime = new Date(date - tzOffset).toISOString().slice(0, -1); // Remove 'Z' at the end
      return localISOTime + 'Z'; // Add 'Z' at the end
    };
    try {
      const responseOne = await axios.get(`/GroupAppointment/${groupLeaderDetails.id}`);
      console.log("responseOne", responseOne);
      const putUpdateData = {
        id: responseOne.data[0].id,
        groupLeaderName: responseOne.data[0].groupLeaderName,
        visitorMobile: responseOne.data[0].visitorMobile,
        visitorCompany: responseOne.data[0].visitorCompany,
        visitorEmail: responseOne.data[0].visitorEmail,
        appointmentStatus: appointmentStatus,
        createdBy: responseOne.data[0].createdBy,
        createdDate: responseOne.data[0].createdDate,
        modifiedBy: responseOne.data[0].modifiedBy,
        modifiedDate: responseOne.data[0].modifiedDate,
        appointmentDate: toLocalISOString(new Date(appointmentDate)),
        meetingVenue: responseOne.data[0].meetingVenue,
        idProofType: responseOne.data[0].idProofType,
        idProofNo: responseOne.data[0].idProofNo,
        validTill: responseOne.data[0].validTill,
        selectedVisitorTypeId: responseOne.data[0].selectedVisitorTypeId,
        txtManagersID: responseOne.data[0].txtManagersID,
        txtFloor: responseOne.data[0].txtFloor,
        txtMeetingRoom: responseOne.data[0].txtMeetingRoom,
        photo: responseOne.data[0].photo,
        txtCostCenter: responseOne.data[0].txtCostCenter,
        checkInTime: responseOne.data[0].checkInTime,
        checkOutTime: responseOne.data[0].checkOutTime,
        gate: responseOne.data[0].gate,
        building: responseOne.data[0].building,
        purpose: responseOne.data[0].purpose,
        assitanceRequired: responseOne.data[0].assitanceRequired,
        serviceProviderAccess: responseOne.data[0].serviceProviderAccess,
        wifiRequired: responseOne.data[0].wifiRequired,
        escort: responseOne.data[0].escort,
        additionalNotification: responseOne.data[0].additionalNotification,
        messageToVisitor: responseOne.data[0].messageToVisitor,
        checkinInstruction: responseOne.data[0].checkinInstruction,
        allDay: responseOne.data[0].allDay,
        repeatVisit: responseOne.data[0].repeatVisit,
        recurrancePattern: responseOne.data[0].recurrancePattern,
        recurEvery: responseOne.data[0].recurEvery,
        selectedRecurrence: responseOne.data[0].selectedRecurrence,
        country: responseOne.data[0].country,
        reason: reasonForRescheduled,
        isCoupon: 1,
        rejectionNotes: null

      }

      if (appointmentStatus == 'rescheduled') {

        const updateAppointmentStaus = await axios.put('/GroupAppointment/GroupAppointReschedule', putUpdateData);
        const empID = localStorage.getItem('employeeId');
        const getManagerDetails = await axios.get(`/Employee/${empID}`);
        console.log("getManagerDetails :", getManagerDetails.data);
        const updatedFormData = {
          toAddress: responseOne.data[0].visitorEmail,
          mailSubject: 'Appointment Rescheduled',
          visitorCompany: responseOne.data[0].visitorCompany,
          visitorName: responseOne.data[0].groupLeaderName,
          hostName: getManagerDetails.data.employeeName,
          employeeMailId: getManagerDetails.data.employeeMailId,
          mailType: 'APPREMAILTOVISITOR',
          visitorMobile: responseOne.data[0].visitorMobile,
          docId: 0,
          meetingOn: toLocalISOString(new Date(appointmentDate)),
          meetingVenue: responseOne.data[0].meetingVenue,
          validTill: responseOne.data[0].validTill,
          foodCoupon: null,
          txtManagersID: null,
          secsEmailId: null,
          duration: null,
          link: null,
          rejectionNotes: reasonForRescheduled,
          managerName: getManagerDetails.data.employeeName,
          managerMail: getManagerDetails.data.managerMailID,
          securityMail: '',
          securityName: '',
          qrCode: '',
          visitorEmail: responseOne.data[0].visitorEmail,
          visitorPhoto: responseOne.data[0].photo,
          visitorType: String(responseOne.data[0].selectedVisitorTypeId),
          meetingTo: responseOne.data[0].validTill,
          gate: responseOne.data[0].gate,
          building: responseOne.data[0].building,
          purpose: null

        }
        console.log("updatedFormData", updatedFormData);
        const updateMail = await axios.post('/Mail', updatedFormData);

        const updatedFormDataHost = {
          toAddress: getManagerDetails.data.employeeMailId,
          mailSubject: 'Appointment Rescheduled',
          hostName: getManagerDetails.data.employeeName,
          visitorMobile: responseOne.data[0].visitorMobile,
          visitorCompany: responseOne.data[0].visitorCompany,
          mailType: 'APPREMAILTOHOST',
          docId: 0,
          meetingOn: toLocalISOString(new Date(appointmentDate)),
          meetingVenue: responseOne.data[0].meetingVenue,
          rejectionNotes: reasonForRescheduled,
          managerName: getManagerDetails.data.employeeName,
          managerMail: getManagerDetails.data.managerMailID,
          visitorEmail: responseOne.data[0].visitorEmail,
          visitorName: responseOne.data[0].groupLeaderName,
          visitorPhoto: responseOne.data[0].photo,
          visitorType: String(responseOne.data[0].selectedVisitorTypeId),
          meetingTo: responseOne.data[0].validTill,
          gate: responseOne.data[0].gate,
          building: responseOne.data[0].building,
          purpose: null

        }
        console.log("updatedFormData", updatedFormDataHost);
        const updateMailHost = await axios.post('/Mail', updatedFormDataHost);
        const fetchVisitorTypeData = async () => {
          try {
            const empID = localStorage.getItem('employeeId');
            const responseOne = await axios.get(`/GroupAppointment/AppUser/${empID}`);
            console.log("responseOne", responseOne);
            setTableData(responseOne.data);
          } catch (error) {
            console.error('Error fetching Visitor Report data:', error);
          }
        };
        fetchVisitorTypeData();
        toast.success("Appointment Rescheduled Successfully")

      }
      if (appointmentStatus == 'cancelled') {
        const updateAppointmentStaus = await axios.put('/GroupAppointment', putUpdateData);

        const empID = localStorage.getItem('employeeId');
        const getManagerDetails = await axios.get(`/Employee/${empID}`);
        console.log("getManagerDetails :", getManagerDetails.data);
        const updatedFormData = {
          toAddress: responseOne.data[0].visitorEmail,
          mailSubject: 'Appointment Cancelled',
          visitorCompany: responseOne.data[0].visitorCompany,
          visitorName: responseOne.data[0].groupLeaderName,
          hostName: getManagerDetails.data.employeeName,
          employeeMailId: getManagerDetails.data.employeeMailId,
          mailType: 'APCMAILTOVISITOR',
          visitorMobile: responseOne.data[0].visitorMobile,
          docId: 0,
          meetingOn: toLocalISOString(new Date(appointmentDate)),
          meetingVenue: responseOne.data[0].meetingVenue,
          validTill: responseOne.data[0].validTill,
          foodCoupon: null,
          txtManagersID: null,
          secsEmailId: null,
          duration: null,
          link: null,
          rejectionNotes: reasonForRescheduled,
          managerName: getManagerDetails.data.employeeName,
          managerMail: getManagerDetails.data.managerMailID,
          securityMail: '',
          securityName: '',
          qrCode: '',
          visitorEmail: responseOne.data[0].visitorEmail,
          visitorPhoto: responseOne.data[0].photo,
          visitorType: String(responseOne.data[0].selectedVisitorTypeId),
          meetingTo: responseOne.data[0].validTill,
          gate: responseOne.data[0].gate,
          building: responseOne.data[0].building,
          purpose: null

        }
        console.log("updatedFormData", updatedFormData);
        const updateMail = await axios.post('/Mail', updatedFormData);

        const updatedFormDataHost = {
          toAddress: getManagerDetails.data.employeeMailId,
          mailSubject: 'Appointment Cancelled',
          hostName: getManagerDetails.data.employeeName,
          visitorMobile: responseOne.data[0].visitorMobile,
          visitorCompany: responseOne.data[0].visitorCompany,
          mailType: 'APCMAILTOVISITOR',
          docId: 0,
          meetingOn: toLocalISOString(new Date(appointmentDate)),
          meetingVenue: responseOne.data[0].meetingVenue,
          rejectionNotes: reasonForRescheduled,
          managerName: getManagerDetails.data.employeeName,
          managerMail: getManagerDetails.data.managerMailID,
          visitorName: responseOne.data[0].groupLeaderName,
          visitorEmail: responseOne.data[0].visitorEmail,
          visitorPhoto: responseOne.data[0].photo,
          visitorType: String(responseOne.data[0].selectedVisitorTypeId),
          meetingTo: responseOne.data[0].validTill,
          gate: responseOne.data[0].gate,
          building: responseOne.data[0].building,
          purpose: null

        }
        console.log("updatedFormData", updatedFormDataHost);
        const updateMailHost = await axios.post('/Mail', updatedFormDataHost);
        const fetchVisitorTypeData = async () => {
          try {
            const empID = localStorage.getItem('employeeId');
            const responseOne = await axios.get(`/GroupAppointment/AppUser/${empID}`);
            console.log("responseOne", responseOne);
            setTableData(responseOne.data);
          } catch (error) {
            console.error('Error fetching Visitor Report data:', error);
          }
        };
        fetchVisitorTypeData();
        toast.success("Appointment Cancelled Successfully");


      }
    } catch (error) {
      setLoading(false); // Start the loader when submitting

      console.error('Error fetching Visitor Report data:', error);
    }

    setAppointmentStatus('scheduled');
    setAppointmentDate(null);
    setReasonForRescheduled('');
    setLoading(false); // Start the loader when submitting

    setIsPopupVisible(false);
  }
  const handleDropdownChange = (event) => {
    setAppointmentStatus(event.target.value);
  };
  const handleReasonChange = (event) => {
    setReasonForRescheduled(event.target.value);
  };
  const handleDateChange = (date) => {
    if (date) {
      setAppointmentDate(date); // Update the state with the new selected date
    }
  };

  const currentDateTime = new Date(); // Current date and time

  // Function to filter out times earlier than the current time
  const filterPassedTime = (time) => {
    if (!(time instanceof Date)) return false;

    const selectedDate = new Date(time);
    const now = new Date();

    const { startHour, startMinute, endHour, endMinute } = timeLimits;

    const selectedMinutes = selectedDate.getHours() * 60 + selectedDate.getMinutes();
    const startMinutes = startHour * 60 + startMinute;
    const endMinutes = endHour * 60 + endMinute;

    const isWithinWorkingHours = selectedMinutes >= startMinutes && selectedMinutes <= endMinutes;

    const isSameDay = now.toDateString() === selectedDate.toDateString();
    const isFutureTime = selectedDate.getTime() > now.getTime();

    return isWithinWorkingHours && (!isSameDay || isFutureTime);
  };


  // Function to highlight the current time
  const highlightTime = (time) => {
    const now = new Date();
    const timeToHighlight = now.getHours() * 60 + now.getMinutes();
    const selectedTime = time.getHours() * 60 + time.getMinutes();

    // Highlight the time close to the current system time
    return selectedTime === timeToHighlight ? 'highlight-time' : '';
  };
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpandCollapse = () => {
    setIsExpanded(!isExpanded);
  };
  const [isExpandedG, setIsExpandedG] = useState(true);
  const toggleExpandCollapseG = () => {
    setIsExpanded(!isExpandedG);
  };
  const [tableDataGroup, setTableDataGroup] = useState([]);
  const [tableDataleader, setTableDataLeader] = useState([]);


  const handleClick = async (item) => {
    console.log("Clicked on:", item);
    setTableDataLeader(item.groupLeaderName)
    setIsPopupVisibleGroup(true)
    try {
      const responseOne = await axios.get(`/GroupMember/${item.id}`);
      console.log("responseOne", responseOne);
      setTableDataGroup(responseOne.data)
    } catch (error) {

    }
    // Your function logic here based on item
  };
  const closePopupG = () => {
    setIsPopupVisibleGroup(false);
  };

  return (
    <Container>
      <ToastContainer />
      <Header>
        <Heading>Group Appointment Status</Heading>
        <SearchBox>
          <SearchIcon size={20} />
          <SearchInput
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </SearchBox>
      </Header>
      <TableContainer>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHeaderCell colSpan={'10'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>Group Appointment  Details</span>
                  <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                    {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                  </IconWrapper>
                </div>
              </TableHeaderCell>

            </TableRow>
          </TableHeader>
          {isExpanded && (
            <>
              <TableHeader>
                <TableRow>
                  <TableHeaderCell>Photo</TableHeaderCell>
                  <TableHeaderCell onClick={() => handleSort('groupLeaderName')}>
                    Group Leader Name
                    {renderSortIcon('groupLeaderName')}
                  </TableHeaderCell>
                  <TableHeaderCell onClick={() => handleSort('visitorCompany')}>Visitor Company {renderSortIcon('visitorCompany')}</TableHeaderCell>
                  <TableHeaderCell onClick={() => handleSort('visitorEmail')}>Visitor Email {renderSortIcon('visitorEmail')}</TableHeaderCell>
                  <TableHeaderCell onClick={() => handleSort('visitorMobile')}>Visitor Mobile {renderSortIcon('visitorMobile')}</TableHeaderCell>
                  <TableHeaderCell onClick={() => handleSort('nationality')}>Nationality {renderSortIcon('nationality')}</TableHeaderCell>
                  <TableHeaderCell onClick={() => handleSort('appointmentDate')}>Appointment Date {renderSortIcon('appointmentDate')}</TableHeaderCell>
                  <TableHeaderCell onClick={() => handleSort('appointmentStatus')}>Appointment Status {renderSortIcon('appointmentStatus')}</TableHeaderCell>
                  <TableHeaderCell onClick={() => handleSort('validTill')}>Valid Up to {renderSortIcon('validTill')}</TableHeaderCell>
                  <TableHeaderCell>Action</TableHeaderCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {currentRows.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Circle> {item.photo ? (
                        <img
                          src={`data:image/png;base64,${item.photo}`}
                          alt="Profile"
                          style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                        />
                      ) : (
                        <ProfileIcon>
                          <User size={15} />
                        </ProfileIcon>
                      )}
                      </Circle>
                    </TableCell>
                    <TableCell><a style={{ color: '#293495', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleClick(item)}
                    >
                      {item.groupLeaderName}
                    </a>
                    </TableCell>
                    <TableCell>{item.visitorCompany}</TableCell>
                    <TableCell>{item.visitorEmail}</TableCell>
                    <TableCell>{item.visitorMobile}</TableCell>
                    <TableCell>{item.nationality}</TableCell>
                    <TableCell>
                      {new Intl.DateTimeFormat('en-CA', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: false
                      }).format(new Date(item.appointmentDate))
                        .replace(',', ' :')}
                    </TableCell>
                    <TableCell>{item.appointmentStatus}</TableCell>
                    <TableCell>
                      {new Intl.DateTimeFormat('en-CA', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: false
                      }).format(new Date(item.validTill))
                        .replace(',', ' :')}
                    </TableCell>
                    <TableCell>
                      <IconWrapper  >
                        <FiEdit data-tooltip-id="status-changes" // Link tooltip to the icon
                          data-tooltip-content='Edit Selected Row'
                          onClick={() => handleIconClick(item)} />
                      </IconWrapper>
                    </TableCell>

                    {isPopupVisible && (
                      <Popup>
                        <LabelValueContainer>
                          <Label>Group Leader Name:</Label>
                          <Value>{groupLeaderDetails.groupLeaderName}</Value>
                        </LabelValueContainer>

                        <LabelValueContainer>
                          <Label>Visitor Mobile:</Label>
                          <Value>{groupLeaderDetails.visitorMobile}</Value>
                        </LabelValueContainer>
                        <DropdownContainer>
                          <DropdownLabel>Appointment Status:</DropdownLabel>
                          <StyledDropdown
                            value={appointmentStatus === "scheduled" ? "" : appointmentStatus}
                            placeholder={appointmentStatus === "scheduled" ? "Please Select" : appointmentStatus}
                            onChange={handleDropdownChange}
                          >
                            <option value="scheduled" >Please Select</option>
                            <option value="rescheduled">Reschedule</option>
                            <option value="cancelled">Cancel</option>
                          </StyledDropdown>
                        </DropdownContainer>
                        {appointmentStatus === 'rescheduled' && (
                          <TextBoxContainerNew>
                            <DropdownLabel>Appointment Date:</DropdownLabel>
                            <StyledDatePicker
                              selected={appointmentDate instanceof Date ? appointmentDate : null}
                              onChange={(date) => handleDateChange(date)}
                              showTimeSelect
                              dateFormat="Pp"
                              minDate={currentDateTime}
                              filterTime={filterPassedTime}
                              timeClassName={highlightTime}
                              placeholderText="Select Meeting Start Date and Time" // Allow the user to clear the selection
                            />


                          </TextBoxContainerNew>
                        )}
                        {appointmentStatus === 'rescheduled' && (
                          <TextBoxContainer>
                            <DropdownLabel>Reason for Reschedule:</DropdownLabel>
                            <TextArea
                              rows="4"
                              value={reasonForRescheduled}
                              onChange={handleReasonChange}
                              placeholder="Please provide a reason for rescheduling"
                            />
                          </TextBoxContainer>
                        )}
                        {appointmentStatus === 'cancelled' && (
                          <TextBoxContainer>
                            <DropdownLabel>Reason for Cancellation:</DropdownLabel>
                            <TextArea
                              rows="4"
                              value={reasonForRescheduled}
                              onChange={handleReasonChange}
                              placeholder="Please provide a reason for Cancellation"
                            />
                          </TextBoxContainer>
                        )}
                        <ButtonContainer>
                          <PopupButton onClick={closePopup} style={{ backgroundColor: 'red' }}>Close</PopupButton>
                          <PopupButton onClick={submitStaus}>Next</PopupButton>
                        </ButtonContainer>
                        {/* Show loader when loading */}
                      </Popup>
                    )}
                    {isPopupVisibleGroup && (
                      <PopupG>
                        <CloseButton onClick={closePopupG}>&times;</CloseButton>
                        <ScrollableTableContainer>
                          <TableContainer>
                            <Table>
                              <TableHeader>
                                <TableRow>
                                  <TableHeaderCell colSpan={'7'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                      <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>{tableDataleader} - Member Details</span>

                                    </div>
                                  </TableHeaderCell>

                                </TableRow>
                              </TableHeader>
                              {isExpanded && (
                                <>
                                  <TableHeader>
                                    <TableRow>
                                      <TableHeaderCell>Photo</TableHeaderCell>
                                      <TableHeaderCell onClick={() => handleSortG('groupMemberName')}>
                                        Member Name
                                        {renderSortIcon('groupMemberName')}
                                      </TableHeaderCell>
                                      <TableHeaderCell onClick={() => handleSortG('visitorMobile')}>Visitor Mobile {renderSortIcon('visitorMobile')}</TableHeaderCell>
                                      <TableHeaderCell onClick={() => handleSortG('company')}>Visitor Company {renderSortIcon('company')}</TableHeaderCell>
                                      <TableHeaderCell onClick={() => handleSortG('nationality')}>Nationality {renderSortIcon('nationality')}</TableHeaderCell>
                                      <TableHeaderCell onClick={() => handleSortG('idProofName')}>Id Proof Type{renderSortIcon('idProofName')}</TableHeaderCell>
                                      <TableHeaderCell onClick={() => handleSortG('idProofNo')}>Id Proof Number{renderSortIcon('idProofNo')}</TableHeaderCell>

                                    </TableRow>
                                  </TableHeader>
                                  <TableBody>
                                    {tableDataGroup.map((item, index) => (
                                      <TableRow key={index}>
                                        <TableCell>
                                          <Circle> {item.photo ? (
                                            <img
                                              src={`data:image/png;base64,${item.photo}`}
                                              alt="Profile"
                                              style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                                            />
                                          ) : (
                                            <ProfileIcon>
                                              <User size={15} />
                                            </ProfileIcon>
                                          )}
                                          </Circle>
                                        </TableCell>
                                        <TableCell style={{ textAlign: 'left' }}>
                                          {item.groupMemberName}
                                        </TableCell>
                                        <TableCell style={{ textAlign: 'left' }}>{item.visitorMobile}</TableCell>
                                        <TableCell style={{ textAlign: 'left' }}>{item.company}</TableCell>
                                        <TableCell style={{ textAlign: 'left' }}>{item.nationality}</TableCell>
                                        <TableCell style={{ textAlign: 'left' }}>{item.idProofName}</TableCell>
                                        <TableCell style={{ textAlign: 'left' }}>{item.idProofNo}</TableCell>
                                      </TableRow>
                                    ))}
                                    <Tooltip id="status-changes" place="top" className="custom-tooltip" />

                                  </TableBody>
                                </>)}
                            </Table>
                          </TableContainer>
                        </ScrollableTableContainer>


                        {/* Show loader when loading */}
                      </PopupG>
                    )}

                  </TableRow>
                ))}
                <Tooltip id="status-changes" place="top" className="custom-tooltip" />

              </TableBody>
            </>)}
        </Table>
      </TableContainer>
      {isExpanded && (
        <>
          <PaginationContainer>
            <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
              Previous
            </PaginationButton>

            <DropdownSelect value={currentPage} onChange={handlePageChange}>
              {Array.from({ length: totalPages }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  Page {i + 1}
                </option>
              ))}
            </DropdownSelect>

            <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
              Next
            </PaginationButton>
          </PaginationContainer>
        </>)}

    </Container>
  );
};

export default AppoinmentStatusPage;
